export enum Type {
    TEXT,
    CHECKBOXE,
  }